import React from 'react'
import { LinkExt, Document, Chapter, Paragraph } from '../components/document.js'
import chirpstackArch from '../../assets/docs/chirpstackArchitecture.png'
import thingsboardArch from '../../assets/docs/thingsboard-architecture.svg'
import DocGraph from '../components/docGraphs';
import InlineDocumentation from '../../components/inlineDocumentation.js';


// import ReactMarkdown from 'react-markdown';
import { documentation as UiAddFieldDoc } from "../../ui/uiAddField";
import { documentation as UiAssignFieldDoc } from "../../ui/uiAssignField"

import { documentation as UiAddDeviceDoc } from "../../ui/uiAddDevice"
import { documentation as UiChsUiDeviceDoc } from "../../ui/chirpstack/chsUiDevice"
import { documentation as UiDeviceHistoryDoc } from "../../ui/uiDeviceHistory"

import { documentation as UiAddCustomerDoc } from "../../ui/uiAddCustomer"
// import * from "../../ui/ui"
import { documentation as UiAssignDashboardDoc } from "../../ui/uiAssignDashboard"
import { documentation as UiGenerateDashboardDoc } from "../../ui/uiGenerateDashboard"

const uiDocuments = [

    { cathegory: "Field", elements: [UiAddFieldDoc, UiAssignFieldDoc] },
    { cathegory: "Device", elements: [UiAddDeviceDoc, UiChsUiDeviceDoc, UiDeviceHistoryDoc] },
    { cathegory: "Customer", elements: [UiAddCustomerDoc] },
    { cathegory: "Dashboard", elements: [UiGenerateDashboardDoc, UiAssignDashboardDoc] },

];

const links = {
    abika: { title: "Abika", link: 'https://www.abikasrl.com/en/' },
    abinsula: { title: "Abinsula", link: "https://www.abinsula.com" },
    EOLAB: { title: "UNICA EOLAB", link: 'https://sites.unica.it/eolab/' },
    acuadoriUnica: { title: 'Acuadori UNICA', link: 'https://sites.unica.it/acuadori/piattaforma-acuadori/' },
    acuadoriThingsboard: { title: 'Thingsboard Server', link: 'https://acuadori.abinsula.com/' },
    acuadoriLorawan: { title: 'LoRaWAN Server', link: 'https://lora-acuadori.abinsula.com/' },
    acuadoriSmartTool: { title: 'Acuadori Smart Tool', link: 'http://acuadori.abinsula.com:1710' },
    chirpstackOriginal: { title: 'Chirpstack.io', link: 'https://www.chirpstack.io' },
    thingsboardOriginal: { title: 'Thingsboard.io', link: 'https://www.thingsboard.io' },
};

const acuaTerms = {
    node: <strong>acua-NODE</strong>,
    sens: <strong>acua-SENS</strong>,
    smart: <strong>acua-SMART</strong>,
    smartTool: <strong>acua-SMART tool</strong>,
    net: <strong>acua-NET</strong>,
    dashboard: <strong>Acuadori Dashboard</strong>,
}


class DocAcuaSmartPlatform extends Document {
    constructor(props) {
        super(props);
        this.state = {
            currentGraphId: ''
        }
    }

    toolPar

    graphNodeChsThb = [
        { position: { x: 40, y: 10 }, id: 'nod1', data: { label: <div><h6>Acua-NODE</h6><p>SuEntu North</p></div> }, sourcePosition: 'right', targetPosition: 'right' },
        { position: { x: 40, y: 110 }, id: 'nod2', data: { label: <div><h6>Acua-NODE</h6><p>SuEntu East</p></div> }, sourcePosition: 'right', targetPosition: 'right' },
        { position: { x: 40, y: 210 }, id: 'nod3', data: { label: <div><h6>Acua-NODE</h6><p>Coop Romangia</p></div> }, sourcePosition: 'right', targetPosition: 'right' },

        { position: { x: 300, y: 40 }, id: 'ch', data: { label: <div><h5>Chirpstack</h5><p>Acuadori</p></div> }, sourcePosition: 'right', targetPosition: 'left', style: { borderColor: 'gray' } },
        { position: { x: 620, y: 40 }, id: 'th', data: { label: <div><h5>Thingsboard</h5><p>Acuadori</p></div> }, targetPosition: 'left', style: { borderColor: 'blue' } },
        { position: { x: 450, y: 210 }, id: 'st', data: { label: <div><h5>Acuadori Smart Tool</h5><p>Abika</p></div> }, sourcePosition: 'top', style: { borderColor: 'red' } },

        { id: 'e-nod1-ch', source: 'nod1', target: 'ch', animated: true, style: { stroke: 'green' }, arrowHeadType: 'arrowclosed' },
        { id: 'e-nod2-ch', source: 'nod2', target: 'ch', animated: true, style: { stroke: 'green' }, arrowHeadType: 'arrowclosed', label: 'acua-SENS Data' },
        { id: 'e-nod3-ch', source: 'nod3', target: 'ch', animated: true, style: { stroke: 'green' }, arrowHeadType: 'arrowclosed' },
        { id: 'e-ch-th', source: 'ch', target: 'th', animated: true, style: { stroke: 'green' }, arrowHeadType: 'arrowclosed', label: 'http connector' },
        { id: 'e-st-ch', source: 'st', target: 'ch', animated: true, style: { stroke: 'red' }, arrowHeadType: 'arrowclosed', label: 'http connector', type: 'straight' },
        { id: 'e-st-th', source: 'st', target: 'th', animated: true, style: { stroke: 'blue' }, arrowHeadType: 'arrowclosed', label: 'http connector', type: 'straight' },
    ];

    graphAcuadoriThbArch = [

        { position: { x: 40, y: 60 }, id: 'device', data: { label: 'Thb Device' }, type: 'input', sourcePosition: 'right' },
        { position: { x: 40, y: 200 }, id: 'field', data: { label: 'Thb Field' }, type: 'input', sourcePosition: 'right' },
        { position: { x: 250, y: 20 }, id: 'dev-op', data: { label: 'Thb Device entity view operator' }, sourcePosition: 'right', targetPosition: 'left' },
        { position: { x: 250, y: 80 }, id: 'dev-ag', data: { label: 'Thb Device entity view agronomist' }, sourcePosition: 'right', targetPosition: 'left' },
        { position: { x: 250, y: 160 }, id: 'field-op', data: { label: 'Thb Field entity view operator' }, sourcePosition: 'right', targetPosition: 'left' },
        { position: { x: 250, y: 220 }, id: 'field-ag', data: { label: 'Thb Field entity view agronomist' }, sourcePosition: 'right', targetPosition: 'left' },

        { position: { x: 460, y: 130 }, id: 'dashboard', data: { label: 'Acuadori Dashboard' }, sourcePosition: 'right', targetPosition: 'left' },

        { position: { x: 650, y: 90 }, id: 'customer-op', data: { label: 'Winerie Operator User' }, type: 'output', sourcePosition: 'right', targetPosition: 'left' },
        { position: { x: 650, y: 160 }, id: 'customer-ag', data: { label: 'Winerie Agronomist User' }, type: 'output', sourcePosition: 'right', targetPosition: 'left' },


        { id: 'e-device-dev-op', source: 'device', target: 'dev-op', animated: true, style: { stroke: 'gray' }, arrowHeadType: 'arrowclosed' },
        { id: 'e-device-dev-ag', source: 'device', target: 'dev-ag', animated: true, style: { stroke: 'gray' }, arrowHeadType: 'arrowclosed' },
        { id: 'e-field-dev-op', source: 'field', target: 'field-op', animated: true, style: { stroke: 'gray' }, arrowHeadType: 'arrowclosed' },
        { id: 'e-field-dev-ag', source: 'field', target: 'field-ag', animated: true, style: { stroke: 'gray' }, arrowHeadType: 'arrowclosed' },

        { id: 'e-dev-op-dashboard', source: 'dev-op', target: 'dashboard', animated: true, style: { stroke: 'red' }, arrowHeadType: 'arrowclosed' },
        { id: 'e-dev-ag-dashboard', source: 'dev-ag', target: 'dashboard', animated: true, style: { stroke: 'blue' }, arrowHeadType: 'arrowclosed' },
        { id: 'e-field-op-dashboard', source: 'field-op', target: 'dashboard', animated: true, style: { stroke: 'red' }, arrowHeadType: 'arrowclosed' },
        { id: 'e-field-ag-dashboard', source: 'field-ag', target: 'dashboard', animated: true, style: { stroke: 'blue' }, arrowHeadType: 'arrowclosed' },

        { id: 'e-dashboard-customer-op', source: 'dashboard', target: 'customer-op', animated: true, style: { stroke: 'red' }, arrowHeadType: 'arrowclosed' },
        { id: 'e-dashboard-customer-ag', source: 'dashboard', target: 'customer-ag', animated: true, style: { stroke: 'blue' }, arrowHeadType: 'arrowclosed' },

    ];


    showGraph = (id) => { this.setState({ currentGraphId: id }) };

    renderShowGraphButton = (id) => {
        let { currentGraphId } = this.state;
        return <button className="btn-sm btn-outline-info m-2 p-2" type="button"
            onClick={() => this.showGraph(currentGraphId === id ? '' : id)}>
            {currentGraphId === id ? 'Hide Graph' : 'Show Graph'}
        </button>
    }

    render() {
        let { currentGraphId } = this.state;
        const { graphNodeChsThb, graphAcuadoriThbArch } = this;
        return (
            <Document
                title='Acua-SMART IOT platform'
                subtitle={<p>Powered by <LinkExt {...links.abika} /> for Acuadori</p>}

                content={
                    <div>
                        <Chapter title='Introduction'>
                            <p> Distribuite Sensors platform for agriculture are a growing technology in which <LinkExt {...links.abika} /> is focused
                                on. <LinkExt {...links.abika} /> experience in embedded systems and web technology maturated in years of project
                                with <LinkExt {...links.abika} /> client portfolio, drives the platform implementation to be a complete, user-friendly solution.
                                From sensor installation, hheterogeneous sensor communication patterns, to data storage, visualization and data analytics.
                            </p>
                            <p>In Acuadori, <LinkExt {...links.abika} /> contributes with the development and the production of:
                                <ul>
                                    <li> a Thingsboard server instance,</li>
                                    <li> a Chirpstack server instance,</li>
                                    <li> with an online platform that automatize and speedup Thingsboard and Chirpstack routines for:
                                        <ul>
                                            <li>device insertion</li>
                                            <li>visualization of device data through the {acuaTerms.dashboard}</li>
                                            <li>field/asset creation</li>
                                            <li>customer (users) creation</li>
                                            <li>references between customer, dashboards, fields and devices</li>
                                            <li>creation of report of the entire history of device data.</li>
                                        </ul>
                                    </li>
                                </ul>
                            </p>

                            <p>The platform is production-ready and is tested with
                                <ul>
                                    <li>UNICA {acuaTerms.acuaNode} with {acuaTerms.sens} and the {acuaTerms.net}, with on-field testing and several months of up-time</li>
                                    <li><LinkExt {...links.abika} /> programs a couple of LoRaWAN gateways and LoRaWAN nodes based on ESP32, with on-field testing</li>
                                    <li>Software-simulated LoRaWAN nodes: Chirpstack and Chirpstack-Thingsboard integration)</li>
                                    <li>Software mqtt devices: Thingsboard mqtt integration</li>
                                    <li>Http integration api through automatized content creation for both Chirpstack and Thingsboard.</li>
                                </ul>
                            </p>
                        </Chapter>

                        <Chapter title="Project Context">

                            <p> The sensor systems core function is to generate data to be used in resource-critical decisions. In the agriculture use-case
                                an efficient water-consumption is one critical factor for success.</p>
                            <p>In Sardinia, Italy and the Mediterranean area, wine is one of the largest agricultural productions.
                                The quality of the wine is important and is closely linked to the amount of water that the vine takes during the year.</p>

                            <p> <LinkExt {...links.EOLAB} /> department designed and produces Acuadori nodes, LoRaWAN nodes equipped with a set of sensors that measure
                                the water-consumption directly on the three.
                                The components of the Acuadori IOT sensor network, the {acuaTerms.net}, are several devices type:
                                <ul>
                                    <li>each physical sensor is an {acuaTerms.sens}, and there are several type, to acquire heterogeneous plant data</li>
                                    <li>{acuaTerms.node} one per plant, acquires the data from sensors and communicates with the network</li>
                                    <li>a LoRaWAN in-field gateway communicates {acuaTerms.node} data to the {acuaTerms.smart} server platform.</li>
                                    <li>the {acuaTerms.smart} platform collect and analyzes data, displaying it in dashboards</li>
                                    <li> {acuaTerms.dashboard} display data content differentiated by the user target.</li>
                                </ul>
                                Through the data collected by each {acuaTerms.node}, by sensing differences on leaf hydration, it can be measured the plant hydration status
                                and consequently manage the amount of water to be supplied to plants.
                            </p>
                            <p>The Acuadori Platform is extensively described in the <LinkExt {...links.acuadoriUnica} /> website.</p>

                            <p><LinkExt {...links.abika} /> design, compose and customize {acuaTerms.smart} the IOT platform.
                                In a large ecosystem of IOT platform that may fit the Acuadori project needs, a customized Thingsboard server has been the choice
                                for Acuadori data-storage, analysis and visualization.
                                In addition, Chirpstack server has been installed and customized by <LinkExt {...links.abika} /> to have a complete IOT solution
                                for LoRaWAN devices that has to communicate with Thingsboard.</p>
                        </Chapter>

                        <Chapter title='Acua-SMART platform'>
                            <p>The Acua-SMART server platform consist in three main elements:
                                <ul>
                                    <li>Chirpstack server @<LinkExt title='lora-acuadori.abinsula.com' link={links.acuadoriLorawan.link} /> </li>
                                    <li>Thingsboard server @<LinkExt title='acuadori.abinsula.com' link={links.acuadoriThingsboard.link} /></li>
                                    <li>A cloud app, the <LinkExt {...links.acuadoriSmartTool} /></li>
                                </ul>
                            </p>
                            <p>A Set of test custom and opensource tools are used to verify platform update and stability:
                                <ul>
                                    <li>{acuaTerms.node}s that sends {acuaTerms.sens} data from fields.</li>
                                    <li><LinkExt {...links.abinsula} /> loraWAN devices (gateway and nodes) based on low-cost heltec boards.</li>
                                    <li>A LoRaWAN node software Simulator, configured with {acuaTerms.smart} LoRaWAN parameters</li>
                                    <li>An <LinkExt {...links.abinsula} /> linux embedded gateway software connected to Thingsboard mqtt and REST api, sending
                                        <ul>
                                            <li>CAN data from a Software-simulated vehicle.</li>
                                            <li>MQTT data from other MQTT network</li>
                                            <li>Websocket json-mapped heterogeneous sensors data.</li>
                                        </ul>
                                    </li>
                                </ul>
                            </p>

                            <Paragraph title='Acua-SMART Platform Components overview'>
                                <p>The component architecture follows.</p>
                                <div className='card border-info'>
                                    {this.renderShowGraphButton('graphNodeChsThb')}
                                    <DocGraph id='graphNodeChsThb' currentGraphId={currentGraphId} style={{ height: 350 }}
                                        elements={graphNodeChsThb} />
                                </div>
                                <p />
                                <p>Each {acuaTerms.node} communicates through LoRaWAN protocol with the <LinkExt {...links.acuadoriLorawan} />,
                                    sending {acuaTerms.sens} data about plant status.
                                    The <LinkExt {...links.acuadoriLorawan} /> a custom parser extracts the {acuaTerms.sens} data from the
                                    one sent by each {acuaTerms.node}. The new data is forwarded using the Thingsboard plugin, that is connected to
                                    <LinkExt {...links.acuadoriThingsboard} /> REST api exposed by Thingsboard HTTP transport module.
                                </p>
                                <p>There is one-to-one correspondence between Chirpstack device and Thingsboard one.</p>
                                <p>Once Thingsboard receives telemetry data from {acuaTerms.node} device, the device data is visualized on
                                    each {acuaTerms.dashboard} it is connected to. Thingsboard data visualization pattern is customized in the <strong>acua-SMART platform</strong>.
                                </p>
                                <p>The Acuadori target users are wineries, that usually owns more than one field and needs distributed data from each field.
                                    The <LinkExt {...links.acuadoriThingsboard} /> is organized to reflect those needs.
                                    There are wineries (<u>customer</u>) with different operators (<u>users</u>) that want to visualize the field's data in different flavours ( {acuaTerms.dashboard}).
                                    Each winery owns fields (<u>assets</u>) and each asset may have one or more {acuaTerms.node} updating the field's data.
                                    All of this relationship is expressed in the Acuadori implementation of the Thingsboard server by setting one or more <u>entity views</u> for each
                                    physical resource (<u>assets</u> and <u>devices</u>) and linking the resource-view to the <u>customer</u>.
                                    In this way, the same {acuaTerms.dashboard} implementation can be shared among all customer users (independently on the user-type) and the field's data is presented
                                    to the user depending on its account type automatically.</p>
                                <p>Adding a device to the  {acuaTerms.smart} platform involves a long sequence of steps, most of which can be automated with few user choices.
                                    To automate some steps in the configuration phase, in order to have in few clicks a new device that can communicate with
                                    the {acuaTerms.smart} platform and visualize its data in the {acuaTerms.dashboard}, <LinkExt {...links.abika} /> develops
                                    the <LinkExt {...links.acuadoriSmartTool} />.
                                    Through the <LinkExt {...links.acuadoriSmartTool} /> the user can easily set up a customer, a field, a device and an {acuaTerms.dashboard}, with facilities that
                                    allow the device to be added to an existing customer {acuaTerms.dashboard} or the creation of a new one. Moreover, all the data of the device are related
                                    to the field to which it belongs.
                                    Although the <LinkExt {...links.acuadoriSmartTool} /> has been primarily developed to automate <LinkExt {...links.acuadoriThingsboard} /> and
                                    the <LinkExt {...links.acuadoriLorawan} />.</p>
                            </Paragraph>

                            <Paragraph title='Acua-SMART LoRaWAN'>
                                <p>In Acuadori <LinkExt {...links.acuadoriLorawan} />, the LoRaWAN Gateway-bridge, Network and application server instances
                                    are delegated to a customized <LinkExt {...links.chirpstackOriginal} /> server.</p>
                                <p>The <LinkExt {...links.chirpstackOriginal} /> server architecture can be summarized with the following image:
                                    <img className='col-12 card border-info' src={chirpstackArch} alt={'Chirpstack Architecture'} />  </p>
                                <p>It is configured with the Acuadori Gateway profile Service and Device profile and a specific application for the acua-NET that is under testing with
                                    the innovative {acuaTerms.node}s and {acuaTerms.sens}es for in-field tests.
                                    The device are a Class-A one, with OTA join support. The {acuaTerms.smart} network nodes uses LoRaWAN MAC version 1.0.0.</p>

                                <p>Allowing a new {acuaTerms.node} to communicate with the <LinkExt {...links.acuadoriLorawan} /> by correctly configuring each LoRaWAN communication
                                    parameter needed by the three LoRaWAN servers (gateway, network and application) to be accepted, can be tricky. </p>

                                <p>The <LinkExt {...links.acuadoriSmartTool} /> accepts the minimum configuration parameters to have the device correctly configured and
                                    automatically linked to the <LinkExt {...links.acuadoriThingsboard} /> and instantaneously starting to view the {acuaTerms.node} sensing data on the {acuaTerms.dashboard}.
                                    By creating the device with the <LinkExt {...links.acuadoriSmartTool} /> it is ensured that the device's name on <LinkExt {...links.acuadoriLorawan} /> and
                                    in the <LinkExt {...links.acuadoriThingsboard} /> servers are registered with the same name.</p>

                                <p>There is another working instance of a LoRaWAN server, a <u>loraserver</u>, installed by <LinkExt {...links.EOLAB} /> team in the early development
                                    phase that supports the first version of the {acuaTerms.node}s. <LinkExt {...links.abika} /> configured there the HTTP connector
                                    to drive the {acuaTerms.net} data to the <LinkExt {...links.acuadoriThingsboard} /> and the test data
                                    can be viewed directly in the {acuaTerms.dashboard}.</p>

                            </Paragraph>

                            <Paragraph title='Acua-SMART User Interface and Data Storage'>
                                <p>The <LinkExt {...links.acuadoriThingsboard} /> allows wineries users to access its own devices, field and data in personalized dashboards.
                                    Devices and fields can send data in a lot of ways, including REST and mqtt. The {acuaTerms.node}s data are collected by the
                                    <LinkExt {...links.acuadoriLorawan} /> and published to the <LinkExt {...links.acuadoriThingsboard} /> through its HTTP telemetry API.
                                    Following, a simplified summary of the thingsboard server:
                                    <p />
                                    <p><img className='col-12 card border-info' style={{ maxHeight: 500 }} src={thingsboardArch} alt={'Thingsboard Architecture'} /></p>
                                    <p />
                                </p>
                                <p>The telemetry {acuaTerms.sens} data published by each {acuaTerms.node} is stored in a PostgreSQL database.</p>
                                <p>The <LinkExt {...links.acuadoriThingsboard} /> has been customized for the Acuadori project. The target users are wineries operators
                                    and agronomists, that have different needs about field's data visualization and manipulation. <LinkExt {...links.abika} /> implemented
                                    the  {acuaTerms.dashboard}, that automatically displays data basing on the logged user type (agronomist or operator). </p>
                                <p />
                                <p className='card border-info'>
                                    {this.renderShowGraphButton('graphAcuadoriThbArch')}
                                    <DocGraph id='graphAcuadoriThbArch' currentGraphId={currentGraphId} style={{ height: 350 }} elements={graphAcuadoriThbArch} />
                                </p>
                                <p />
                                <p>The {acuaTerms.dashboard} component displays data basing on the relations between the <strong>customer user</strong> and
                                    the field's <strong>entity views</strong>. The device list for each field is displayed instead by querying the <strong>devices entity views</strong> that
                                    are related to a <strong>field entity view</strong>.</p>
                                <p> Although this relationship hierarchy is necessary to tell each user-dashboard which data to take care of and visually update, on the other side
                                    it allows the device data to be driven to the correct user and the automatic sharing of all {acuaTerms.dashboard} improvements to all customers that
                                    own that dashboard. In addition, the relationship hierarchy maps the client's resource ownership.
                                </p>
                                <p> The explicitation of relationships between the client and the resources assigned to it by in form of <strong>entity views</strong> instead of
                                    directly assigning the resource to it allows the tenant administrator to expose the devices and fields data to be shared between different customers.
                                    This use-case is relevant for both:
                                    <ul>
                                        <li>discerning the winery user-type (operator/agronomist) that are mapped in thingsboard with different customer;</li>
                                        <li>sharing some device or field data (coming from the same data-source) between different customers,
                                            without the need to share all customer's data giving a customer account to third-parties.
                                            It is enough to create another <strong>entity view</strong> of the resource, choose the data to share and assign
                                            that <strong>entity view</strong> to another customer.</li>
                                    </ul>
                                </p>
                            </Paragraph>

                            <Paragraph title='Acua-SMART Tool'>
                                <p> There is an 'invisible architecture' in the <LinkExt {...links.acuadoriThingsboard} /> that allows the {acuaTerms.dashboard} to work correctly:
                                    a set of naming-conventions and relationships allows the {acuaTerms.dashboard} to query the Thingsboard core and receive
                                    all the user devices and fields with a specific format to correctly render the user interface.
                                </p>
                                <p>This is the main reason that leads <LinkExt {...links.abika} /> to develop from scratch the {acuaTerms.smartTool}.
                                    The {acuaTerms.smartTool} is a cloud app that automates the resource creation on
                                    the <LinkExt {...links.acuadoriThingsboard} /> and <LinkExt {...links.acuadoriLorawan} /> with cross-server connections and
                                    thingsboard internal connections and relations.</p>

                                <p> The {acuaTerms.smartTool} acts through <LinkExt {...links.acuadoriThingsboard} /> and  <LinkExt {...links.acuadoriLorawan} /> REST api to
                                    add new resources, link existing one or mix the two to achieve the correct instance of the new resource in order to be displayed
                                    in the {acuaTerms.dashboard} of the chosen customer's users.
                                </p>
                            </Paragraph>
                        </Chapter>

                        <Chapter title="The Acua-Smart Tool">

                            <p>As introduced in the <a href='#Acua-SMART Tool'>Acua-SMART Tool paragraph</a>, the {acuaTerms.smartTool} has been developed specifically to automatize
                                data path linking of <LinkExt {...links.acuadoriThingsboard} /> resources and linking of the device <LinkExt {...links.acuadoriLorawan} /> instance
                                with its corresponding Thingsboard one.</p>

                            <p> The {acuaTerms.smartTool} has been developed to help the engineers in installation phase, making possible in a few clicks to have a new device instance
                                in the <LinkExt {...links.acuadoriLorawan} />, related to an existing or a brand-new device instance on <LinkExt {...links.acuadoriThingsboard} />, with the ability
                                to view the LoRaWAN data from the new {acuaTerms.node} online, in the {acuaTerms.dashboard}, <strong><u>from the smartphone</u></strong>. </p>

                            <p>There are some other features, like the possibility to download a {acuaTerms.smartTool} device time-series in json. </p>
                            <p>The {acuaTerms.smartTool} is a <LinkExt title="React application" link='https://reactjs.org/' />, developed with component architecture and the code
                                is hosted in the <LinkExt {...links.abinsula} /> gitlab. </p>
                            <p>The {acuaTerms.smartTool} actual public address is <LinkExt title={links.acuadoriSmartTool.link} link={links.acuadoriSmartTool.link} />.
                            </p>
                            <p>This Chapter is dedicated to the {acuaTerms.smartTool} procedure documentation.</p>
                            <p>
                                The documentation of each procedure is displayed on each procedure page to improve the user experience. Following,
                                an aggregated list of the </p>
                            <p>{
                                uiDocuments.map(items =>
                                    <Paragraph title={items.cathegory + ' Operations'}>
                                        {
                                            items.elements.map(doc => {
                                                let contentList = doc.steps.map((step) => {
                                                    return { title: step.title, content: <p><p>{step.brief}</p><p>{step.content}</p></p> };
                                                });
                                                return (<InlineDocumentation title={doc.title} subtitle={doc.subtitle} brief={doc.brief}
                                                    content={
                                                        <p>{doc.content}
                                                            <p>
                                                                <p />
                                                                <h4 className='text-success'>STEPS:</h4>
                                                            </p>
                                                        </p>}
                                                    contentList={contentList} />)

                                            })}
                                    </Paragraph>
                                )
                            }
                            </p>

                        </Chapter>

                    </div>
                }>
            </Document>
        )
    }
}
let documentation = {
    type: 'document',
    title: 'Acua-SMART IOT platform',
    document: <DocAcuaSmartPlatform />,
};

let chapter = {
    type: 'chapter',
    chapters: [
        {
            name: 'Introduction',
            paragraph: []
        },
        {
            name: 'Project Context',
            paragraph: []
        },
        {
            name: 'Acua-SMART platform',
            paragraph: [
                'Acua-SMART Platform Components overview',
                'Acua-SMART LoRaWAN',
                'Acua-SMART User Interface and Data Storage',
                'Acua-SMART Tool'
            ]
        },
        {
            name: 'The Acua-Smart Tool',
            paragraph: [
                'Field Operations',
                'Device Operations',
                'Customer Operations',
                'Dashboard Operations',
            ]
        },

    ]
}

export { documentation as AcuadoriPlatformDocumentation };
export { chapter as AcuadoriPlatformDocumentationChapter };
